import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface Announcement {
  id: string;
  severity: 'info' | 'warning' | 'critical';
  title: string;
  message: string;
  startsAt?: string;
  expiresAt: string;
  createdAt: string;
}

export class AnnouncementsApi {
  constructor(private readonly http: HttpClient) {}

  listActive(): Observable<Announcement[]> {
    return this.http.get<Announcement[]>('/announcements/active');
  }
}
